export const PERMISSION_RESOURCE_CODES = {
  overview: 'investment-overview',
  lead: 'investment-leads',
  relationship: 'investment-relationships',
  project: 'investment-projects',
  decision: 'investment-decisions',
  transaction: 'investment-transactions',
  dashboard: 'investment-dashboard',
  settings: 'investment-settings',
} as const;

export const PERMISSION_ACTION_CODES = {
  overview: { view: 'view' },
  lead: { view: 'view', create: 'create', edit: 'edit', manage: 'manage' },
  relationship: { view: 'view', edit: 'edit', manage: 'manage' },
  project: { view: 'view', edit: 'edit', manage: 'manage' },
  decision: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
    approve: 'approve',
  },
  transaction: {
    view: 'view',
    edit: 'edit',
    manage: 'manage',
    approve: 'approve',
  },
  dashboard: { view: 'view' },
  settings: { view: 'view', manage: 'manage' },
};

export const PERMISSION_VIEW_CODES = {
  overview: `${PERMISSION_RESOURCE_CODES.overview}:${PERMISSION_ACTION_CODES.overview.view}`,
  lead: `${PERMISSION_RESOURCE_CODES.lead}:${PERMISSION_ACTION_CODES.lead.view}`,
  relationship: `${PERMISSION_RESOURCE_CODES.relationship}:${PERMISSION_ACTION_CODES.relationship.view}`,
  project: `${PERMISSION_RESOURCE_CODES.project}:${PERMISSION_ACTION_CODES.project.view}`,
  decision: `${PERMISSION_RESOURCE_CODES.decision}:${PERMISSION_ACTION_CODES.decision.view}`,
  transaction: `${PERMISSION_RESOURCE_CODES.transaction}:${PERMISSION_ACTION_CODES.transaction.view}`,
  dashboard: `${PERMISSION_RESOURCE_CODES.dashboard}:${PERMISSION_ACTION_CODES.dashboard.view}`,
  settings: `${PERMISSION_RESOURCE_CODES.settings}:${PERMISSION_ACTION_CODES.settings.view}`,
} as const;
